/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Otp_DescriptionInputs */

const he_auth_signup_otp_description = /** @type {(inputs: Auth_Signup_Otp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזינו את הקוד החד-פעמי שנשלח אל`)
};

const en_auth_signup_otp_description = /** @type {(inputs: Auth_Signup_Otp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the one-time code sent to`)
};

/**
* | output |
* | --- |
* | "Enter the one-time code sent to" |
*
* @param {Auth_Signup_Otp_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_otp_description = /** @type {((inputs?: Auth_Signup_Otp_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Otp_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_otp_description(inputs)
	return en_auth_signup_otp_description(inputs)
});